export enum NiveisValor {
  Crush = 0,
  Paquera = 80,
  Paixao = 300,
  Amor = 900
}
